import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { ExaDbUpdateTagsCdbProps, newExaDbUpdateTagsCdb } from "./ExaDbUpdateTagsCdb";

export interface ExaDbEditTagsCdbProps extends OperationActionProps {
  databaseId: string;
  defaultTags?: { name: string; value: string; }[];
}

const ExaDbEditTagsCdb = (
  { targetId, location, databaseId, defaultTags, onExecute, onCancel }: ExaDbEditTagsCdbProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsCdb } = useOperation<ExaDbUpdateTagsCdbProps>(newExaDbUpdateTagsCdb);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        const tags: { name: string; value: string; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTagsCdb({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newExaDbEditTagsCdb = (
  props: ExaDbEditTagsCdbProps,
): JSX.Element => (<ExaDbEditTagsCdb {...props} />);
